import {
  scrollToSmoothly,
  smoothScrollToElement,
  handleTouchStart,
  handleTouchMove,
  inflectNumber,
  isLoggedIn,
  addNotification,
  addInternalNotification,
  addExternalNotification,
  sendAdminNotification,
  openLoginModal,
  countClicks,
  initializeScrollbar,
  stickyFollowHeader,
  extractPixelValue,
  sanitizeHTML,
  redirectToPromoPage, weekDayToString, generatePolishRegex
} from '../../assets/js/utils';

export default {
  data() {
    return {
      tooltipList: [],
      worldContinents: ['World', 'Europe'],
      allDisciplines: [ //index < 0 -> discipline has own svg icon
        { title: 'Baseball', search: true, index: 9, count: 0 },
        { title: 'Dart', search: true, index: 10, count: 0 },
        { title: 'E-sport', search: true, index: 11, count: 0 },
        { title: 'Hokej', search: true, index: 2, count: 0 },
        { title: 'Koszykówka', search: true, index: 3, count: 0 },
        { title: 'Piłka nożna', search: true, index: 0, count: 0 },
        { title: 'Piłka ręczna', search: true, index: 19, count: 0 },
        { title: 'Siatkówka', search: true, index: 4, count: 0 },
        { title: 'Sporty motorowe', search: true, index: 24 },
        { title: 'Sporty walki', search: true, index: 5, count: 0 },
        { title: 'Sporty zimowe', search: true, index: 6, count: 0 },
        { title: 'Tenis', search: true, index: 1, count: 0 },
        { title: 'Żużel', search: true, index: -2, count: 0 },
        { title: 'Inne', search: true, index: -4, count: 0 },
      ],
      otherDisciplines: [
        { title: 'Badminton', search: true, index: 7 },
        { title: 'Bandy', search: true, index: 8 },
        { title: 'Futbol Aus.', search: true, index: 13 },
        { title: 'Futsal', search: true, index: 14 },
        { title: 'Golf', search: true, index: 15 },
        { title: 'Kolarstwo', search: true, index: 16 },
        { title: 'Krykiet', search: true, index: 17 },
        { title: 'Piłka nożna plaż.', search: true, index: 18 },
        { title: 'Piłka wodna', search: true, index: 20 },
        { title: 'Siatkówka plaż.', search: true, index: 22 },
        { title: 'Snooker', search: true, index: 23 },
        { title: 'Tenis stołowy', search: true, index: 25 },
        { title: 'Unihokej', search: true, index: 26 },
        { title: 'Wyścigi konne', search: true, index: 27 },
        { title: 'Formuła 1', search: true, index: 24, count: 0 },
        { title: 'Futbol Am.', search: true, index: 12, count: 0 },
        { title: 'Rugby', search: true, index: 21, count: 0 },
        { title: 'lekkoatletyka', search: true, index: -3, count: 0 },
        { title: 'Wyścigi hartów', search: true, index: -1},
        { title: 'Wyścigi konne', search: true, index: -1},
        { title: 'Inna', search: true, index: -5, count: 0 },
      ],
    }
  },
  mounted() {
    setTimeout(this.refreshTooltips, 300);
  },
  methods: {
    isLoggedIn,
    refreshTooltips() {
      let tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      tooltipTriggerList = tooltipTriggerList.filter(el => !el.getAttribute('data-tooltip-created'));
      tooltipTriggerList.forEach(el => el.setAttribute('data-tooltip-created', '1'));
      this.tooltipList = this.tooltipList.concat(tooltipTriggerList.map(function (tooltipTriggerEl) {
        const tooltip = new Tooltip(tooltipTriggerEl, {
          popperConfig: function (defaultBsPopperConfig) {
            let index = defaultBsPopperConfig.modifiers.findIndex(el => el.name === 'flip');
            defaultBsPopperConfig.modifiers.splice(index, 1);
            defaultBsPopperConfig.strategy = 'fixed';
            return defaultBsPopperConfig;
          },
        });

        function closeTooltipOnClickOutside(event) {
          if (!tooltip._element.contains(event.target)) {
            tooltip.hide();
          }
        }
        document.addEventListener('click', closeTooltipOnClickOutside);
        return tooltip;
      }));
    },
    hideTooltips() {
      this.tooltipList.forEach(tooltip => {
        tooltip.hide();
        if (tooltip._element) {
          tooltip.dispose();
        }
        document.querySelectorAll('[data-tooltip-created]')
          .forEach(el => el.removeAttribute('data-tooltip-created'));
      });
      this.tooltipList = [];
    },
    addNotification,
    addInternalNotification,
    addExternalNotification,
    sendAdminNotification,
    scrollToSmoothly,
    smoothScrollToElement,
    handleTouchStart,
    handleTouchMove,
    inflectNumber,
    openLoginModal,
    blockScrolling() {
      document.documentElement.classList.add('!overflow-hidden');
    },
    unblockScrolling() {
      document.documentElement.classList.remove('!overflow-hidden');
    },
    getBookiePromoLink(bookmakerName) {
      let bookieName = bookmakerName.toLowerCase();
      if (['betclic', 'betcris', 'betfan', 'betway', 'betx', 'forbet', 'fortuna', 'lvbet', 'superbet', 'totalbet', 'totolotek'].includes(bookieName)) {
        return `/kod-promocyjny-${bookieName}/`;
      }
      if (['betters', 'bwin', 'comeon', 'fuksiarz', 'sts', 'admiralbet', 'lebull'].includes(bookieName)) {
        return `/${bookieName}-kod-promocyjny/`;
      }
      if (bookieName === 'goplusbet') {
        return '/gobet-kod-promocyjny/';
      }
      if (bookieName === 'wettarena') {
        return '/wett-arena-kod-promocyjny/';
      }
      if (bookieName === 'etoto' || bookieName === 'pzbuk') {
        return `/kod-bonusowy-${bookieName}/`;
      }
    },
    bookmakerNameToUpperCase(bookmakerName) {
      let bookieName = bookmakerName.toLowerCase();
      if (bookieName === 'sts') {
        return 'STS';
      } else if (bookieName === 'lvbet') {
        return 'LVBet';
      } else if (bookieName === 'goplusbet') {
        return 'GoPlusBet';
      } else if (bookieName === 'betx') {
        return 'BetX';
      } else if (bookieName === 'betcris') {
        return 'BetCris';
      } else {
        return bookieName.charAt(0).toUpperCase() + bookieName.slice(1);
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    },
    countClicks,
    mountComponents() {
      let elements = document.querySelectorAll('[data-component]:not([data-v-app])');
      createAndMountApp([], [], elements);
    },
    initializeScrollbar,
    stickyFollowHeader,
    extractPixelValue,
    sanitizeHTML,
    redirectToPromoPage,
    generatePolishRegex,
    weekDayToString,
    removeUnicodeIcons(text) {
      if (!text) {
        return '';
      }
      return text.replace(/[^\x00-\x7FąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, '').trim();
    },
    removeUnicodeLeaveEmojis(text) {
      if (!text) {
        return '';
      }
      return text.replace(/[^\x00-\x7FąćęłńóśźżĄĆĘŁŃÓŚŹŻ\p{Emoji_Presentation}]/gu, '').trim();
    },
    handleUserAvatarError(event) {
      event.target.src = '/wp-content/themes/zawodtyper/assets/images/default-avatar.webp';
    }
  },
}